"use client"

/** Visible column title everywhere the Leo spotted column appears. */
export const LEO_SPOTTED_COLUMN_LABEL = "Leo Spotted"

export function LeoSpottedColumnHeader() {
  return (
    <span className="inline-flex min-w-0 items-center gap-1.5">
      <i
        className="fa-duotone fa-solid fa-star-christmas shrink-0 text-[0.6875rem] leading-none text-brand"
        aria-hidden
      />
      <span>{LEO_SPOTTED_COLUMN_LABEL}</span>
    </span>
  )
}
